const STORE_AVAILABILITY = {
  storeOpened: 'Loja aberta',
  storeClosed: 'Loja fechada',
  opened: 'Aberta',
  closed: 'Fechada',
  closedPoc: 'LOJA FECHADA',
  openedPoc: 'LOJA ABERTA',
  cancel: 'Cancelar',
  closeStore: 'Fechar loja',
  openStore: 'Abrir loja',
  closeStoremodalTitle: 'Puts! Tem certeza?',
  closeStoreModalTitleV2: 'Fechar loja agora?',
  openStoreModalTitle: 'Opa! Você esta prestes a abrir sua loja, tem certeza?',
  openStoreModalTitleV2:
    'Você está prestes a abrir sua loja. Tem certeza de que quer continuar?',
  closeStoreCallAction:
    'Por favor, informe-nos o motivo de fechar sua loja para que possamos ajudá-lo a não perder vendas!',
  closeStoreCallActionV2:
    'Conta pra gente o motivo do fechamento. Assim a gente entende melhor como te ajudar a não perder vendas.',
  observationText:
    'A qualquer momento você pode reabrir sua loja via plataforma!',
  observationTextV2:
    'Você pode reabrir sua loja a qualquer momento pela plataforma.',
  reasons: [
    { label: 'Falta motoboy', value: 'DELIVERYMAN' },
    { label: 'Sem estoque', value: 'STOCKOUT' },
    { label: 'Sem energia', value: 'ENERGY' },
    { label: 'Sem internet', value: 'INTERNET' },
    { label: 'Estava fazendo hora extra', value: 'OVERTIME' },
    { label: 'Outro', value: 'OTHER' },
  ],
  missingReason: 'Por favor justifique o motivo de fechar a loja!',
  closeStoreReminderText: 'Não se esqueça de fechar a loja antes de ir embora',
  changeAvailabilityBlock:
    'Não é possível desativar a modalidade de pedidos programados.',
  otherReasonPlaceholder: 'Outro motivo',
}

export default STORE_AVAILABILITY
